import { Card } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import { connect } from 'react-redux';
import BaseFeature from './BaseFeature';
import { ANTI_FLICKER } from '../../../../../../utils/constantFeatures';
import { Trans } from 'react-i18next';

class AntiFlicker extends BaseFeature {

    constructor(props) {
        super(props);
        this.state = {
            isEnabled: this.props.properties[ANTI_FLICKER.enable].value === "1" ? true : false
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {
        const v = value;
        this.props.handleChange(propertyName, v);

        if (this.getCorrectPropertyName(propertyName) === ANTI_FLICKER.enable) {
            this.setState({ isEnabled: v === "1" });
        }
    }

    render() {
        const antiFlickerEn = this.props.properties[ANTI_FLICKER.enable];

        return (
            <div className="flex-row">
                <Card className={this.getClassName([antiFlickerEn])}>
                    <div className="card-header-feature">
                        {<Trans i18nKey="anti_flicker" />}
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                        <PropertySwitch
                            property={antiFlickerEn}
                            title={antiFlickerEn.info.displayName}
                            handleChange={this.handleChange} />
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AntiFlicker);
